/* eslint-disable no-console */
import { Wrap } from './styles';

import Layer from 'services/models/Layer';
import geoAlert from 'services/utils/alert';
import { getPropertiesChangedOldFeature, getFeaturesTurf } from 'services/utils/layerUtils';
import { measureArea } from 'services/utils/measures';

import ButtonTooltip from '../../ButtonTooltip';

import {CustomModalSaveAsLayer} from 'views/MapView/components/CustomModalSaveAsLayer';

import Icon from '@map/components/Icons';
/**
 * Turf é uma coleção de módulos com algoritmos geográficos.
 */
import * as turf from '@turf/turf';
/**
 * useFormik é um hook personalizado do React que retornará
 * todos os estados e auxiliares do Formik diretamente.
 */
import { useFormik } from 'formik';
/**
 * Importação da biblioteca leaflet a qual utiliza o OpenStreetMap,
 * é uma biblioteca de mapeamento leve e de codigo aberto, utiliza um banco
 * de dados geografico editável gratuito.
 */
import L from 'leaflet';
/**
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 * 
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional.
 * 
 * useCallback é um hook que retorna uma função de retorno
 * de chamada memorizada
 */
import { useState, useEffect, useCallback } from 'react';
import ReactDOM from 'react-dom';
import LineSliceAtIntersection from 'turf-line-slice-at-intersection';
import SliderColorPicker from 'views/MapView/components/SliderColorPicker';
import AlertConfirm from 'views/MapView/components/ToolBar/components/Analysis/IdentifyFeatureLocation/components/AlertConfirm';
/**
 *  useMap é um hook personalizado criado para gerenciar a comunicação
 *  dos componentes com o mapa.
 */
import { useMap } from 'views/MapView/hooks';
import * as Yup from 'yup';
/**
 * Ferramenta Clip
 * Uma funcionalidade usada em camadas criadas e importadas do tipo polígono
 * Com ela é possivel criar um poligo a partir da área de sobreposição comum
 * entre as feições de uma ou duas camadas selecionadas no menu de camadas.
 * Também é posśivel especificar as feições selecionando-as na tabela de atributos.
 * 
 * @param {string} mapContext Context
 * @param {boolean} isActive Verificação
 * @param {boolean} setIsActive Seta o estado
 * @param {*} props Resto
 * @returns 
 */
export const Clip = ({ mapContext, isActive, setIsActive, ...props }) => {  
  const [arrSelectedLayers, setArrSelectedLayers] = useState([]);
  const [saveModalOpen, setSaveModalOpen] = useState(false);  
  const [runingClip, setRuningClip] = useState(false);
  const [collectionClip, setCollectionClip] = useState({});
  const [type, setType] = useState('');
  const { layers, map, addLayer, setLoadingInMap} = useMap();

  const formik = useFormik({
    initialValues: {
      layerName: '',
      layerStyle: null,
    },
    validationSchema: Yup.object().shape({
      layerName: Yup.string().required('Campo obrigatório'),
    }),
    onSubmit: (values) => {
      saveAsLayer(values.layerName, values.layerStyle);      
      ReactDOM.render(
        <AlertConfirm
          title='Recortar'          
          buttonStyle={{ width: '100px', marginTop: '30px' }}
          message='A geometria gerada pode sofrer deslocamento da posição de origem.'
          buttonText='Ok'
        />,
        document.getElementById('alert')
      );      
    },
  });

  const { resetForm } = formik;

  /**
   * Salva a operação de clip realizada em uma nova camada, que será lista no menu
   * @param {*} layerName Nome que deverá aparecer no menu
   * @param {*} layerStyle Estilo de como a camada deverá ser representada no mapa   
   */
  const saveAsLayer = useCallback((layerName, layerStyle) => {
    if (collectionClip) {      
      const customRender = L.canvas({ pane: 'mixedPane' });
      let options = {
        pane: 'mixedPane',
        renderer: customRender,
        style: layerStyle,
        pointToLayer: function (feature, latlng) {
          return L.circleMarker(latlng, {
            pane: 'mixedPane',
            ...layerStyle,
            renderer: customRender,
          });
        },
      };

      const geoJsonLayer = L.geoJSON(collectionClip, options);
      let layerToAdd = new Layer(
        null,
        'criada',
        null,
        layerName,
        null,
        null,
        null,
        null,
        null
      );      
      layerToAdd.setLeafletLayer(geoJsonLayer);
      layerToAdd.setLayerStyle(layerStyle);      
      let countIdFeature = 1;      
      layerToAdd.leafletLayer.eachLayer((feature) => {        
        let newFeatureProperties = {};
        newFeatureProperties.ID_GBA = countIdFeature;
        newFeatureProperties = {
          ...newFeatureProperties,
          ...feature.feature.properties,
        }
        if(collectionClip.features[0].geometry.type !== "Point" && collectionClip.features[0].geometry.type !== "MultiLineString") {          
          newFeatureProperties['Área (m²)'] = measureArea(feature.feature.geometry.coordinates, true);
          newFeatureProperties['Área (ha)'] = measureArea(feature.feature.geometry.coordinates, true) / 10000;
        }
        feature.feature.properties = newFeatureProperties;
        
        countIdFeature++;
      });
      addLayer(layerToAdd);      
      setSaveModalOpen(false);
    }    
  }, [collectionClip, addLayer]);

  /**
   * Reseta formik para estado inicial e fecha modal
   */
  const handleCloseSaveModal = useCallback(() => {
    resetForm();
    setSaveModalOpen(false);
  }, [resetForm]); 
  
  /**
   * Executa operação de clip sobre as feições
   * mantendo as respectivas colunas das feições envolvidas
   * renomeando-as com _X no final do label
   */
  const intersectFeatures = useCallback((arrFeaturesInitialLayer, arrFeaturesClipLayer ) => {    
    let arrIntersectedFeatures = [];

    //Transforma array de feiçoes da camada de recorte em feature collection
    let collection = turf.featureCollection(arrFeaturesClipLayer)
    //Dissolve
    let dissolve = turf.dissolve(collection)
    //Combina as feiçoes
    let combine = turf.combine(dissolve)    
    //Seta as propriedades da feição
    combine.features[0].properties = collection.features[0].properties
    let clipLayer = []
    clipLayer.push(...combine.features)

    // Line
    if(["LineString", "MultiLineString"].includes(arrFeaturesInitialLayer[0].geometry.type)) {
      // Itera em cada feição do array de linhas     
      arrFeaturesInitialLayer.forEach((line, index) => {
        let arrLineSegment = [];
        let arrVertexToMultiLine = []
        // Itera em cada poligono
        for (let nextPolygon = 0; nextPolygon <= arrFeaturesClipLayer.length - 1; nextPolygon++) {   

          //Transforma poligono para linha para verificação se existe intersecção
          let polygonToLine = turf.polygonToLine(arrFeaturesClipLayer[nextPolygon])
          //  Verifica se tem intersecção
          let hasIntersect = turf.lineIntersect(line, polygonToLine)          
          if(hasIntersect.features.length > 0) {
           
            let arrIntersectedLine = [];
            let arrVertexIntersectedLine = [];
            let newFeatureProperties = {};

            // Pega a feiçao de linha e recorta ela em novas linhas baseado em seus vertices
            for (let nextCoordinate = 0; nextCoordinate < line.geometry.coordinates.length - 1; nextCoordinate++) {
              //  Pega a posição inicial e final da linha recortada  
              let separateLines = turf.lineString([ line.geometry.coordinates[nextCoordinate], line.geometry.coordinates[nextCoordinate + 1] ])
              //  Pega a linha separada e verifica se tem interseção com o poligono
              let intersectLineWithPolygon = LineSliceAtIntersection(separateLines ,arrFeaturesClipLayer[nextPolygon])
              //  Seta no array as interseções
              arrLineSegment.push(intersectLineWithPolygon)
            }     
            // Mapeia o array com linhas ja separadas e dentro dele ja tem as informações das interseções
            arrLineSegment.forEach((line, index) => {
              //  Pega o primeiro ponto da linha cortada
              let pointInitial = line.features[0].geometry.coordinates[0]
              //  Verifica se o ponto esta contido no poligono
              let contain = turf.booleanPointInPolygon(pointInitial, arrFeaturesClipLayer[nextPolygon])
              
              // For para mapear os pedaços das linhas ja separadas(interseções)
              for (let i = 0; i < line.features.length; i++) {
                //  Caso não esteja contido retorna todos os pedaços impares
                if(!contain){
                  if(i % 2 === 1){
                    arrIntersectedLine.push(line.features[i])
                  }
                }
                //  Caso esteja contido retorna todos os pedaços pares
                if(contain){
                  if(i % 2 === 0){
                    arrIntersectedLine.push(line.features[i])
                  }
                }
              }
            })

            // Array com os pedaços de linha que estao contidos dentro dos poligonos
            arrIntersectedLine.forEach((l) => {            
              // Pega o ponto inicial e final do pedaço de linha que esta contido no poligono e seta no array
              arrVertexIntersectedLine.push(l.geometry.coordinates[0], l.geometry.coordinates[1])  
            }) 

            //  Variaveis criadas para calculo de tamanho(comprimento) de cada pedaço que esta contido
            //  nos poligonos das multilineString que serao geradas            
            let lineTemp
            let lengthLineTemp = 0
            let lengthLineFinal = 0
                      
            // Mapeia array que contem todos os pontos contidos de feição em feição
            for (let i = 0; i < arrVertexIntersectedLine.length; i++) {
              //  Pega só os indices pares
              if(i % 2 === 0){
                //  Transforma os pedaços dentro do poligono em novas linhas
                arrVertexToMultiLine.push([ arrVertexIntersectedLine[i], arrVertexIntersectedLine[i+1] ])
                // Linha temporaria criada para fazer o calculo do comprimento do pedaçõ da linha do poligono
                lineTemp = turf.lineString([ arrVertexIntersectedLine[i], arrVertexIntersectedLine[i+1] ])
                // Calcula o tamanho do pedaço da linha
                lengthLineTemp = turf.length(lineTemp, {units: 'meters'})            
                // Soma as os pedaços das linhas de uma mesma feição primaria 
                lengthLineFinal = lengthLineTemp + lengthLineFinal
              }
            } 
            lengthLineFinal = lengthLineFinal.toFixed(2)

            // Verificação para nao levar propertires nulas para a tabela
            if(arrVertexIntersectedLine.length > 0) {
              // Pega as propriedades               
              newFeatureProperties = {
                ...getPropertiesChangedOldFeature(line.properties),
                //  Seta o tamanho do(s) pedaço(s) da linha de uma feição primaria que esta interseccionando com o poligono
                'Comprimento (m)': lengthLineFinal
              }
            }

            // Seta multilines respeitando a feição e mantendo as propriedades da linha original
            arrIntersectedFeatures.push(turf.multiLineString(arrVertexToMultiLine, newFeatureProperties))
          }          
        }
      });          

      return arrIntersectedFeatures;
    }
    
    // Point
    if(["Point", "MultiPoint"].includes(arrFeaturesInitialLayer[0].geometry.type)){
      arrFeaturesInitialLayer.forEach((point) => {
        // Verifica se os pontos estao dentro do poligono dissolvido de clip
        let p = turf.pointsWithinPolygon(point, clipLayer[0])
        if(p.features.length > 0){
          point['properties'] = {
            ...getPropertiesChangedOldFeature(point.properties)
          }
          arrIntersectedFeatures.push(point)
        }
      })

      return arrIntersectedFeatures;
    }

    // Polygon
    if(["Polygon", "MultiPolygon"].includes(arrFeaturesInitialLayer[0].geometry.type)){
      arrFeaturesInitialLayer.forEach((featurePolygon) => {
        //Seta as interseções
        arrIntersectedFeatures.push(
          turf.intersect(featurePolygon, clipLayer[0], { properties: {...getPropertiesChangedOldFeature(featurePolygon.properties)} })
        );
      });
      
      return arrIntersectedFeatures;
    }

    return arrIntersectedFeatures;
  }, []);

  /**
   * Inicia procedimento para execução da interseção
   */
  const runClip = useCallback(() => {         
    if (!runingClip) {
      setRuningClip(true);
      setLoadingInMap(true);
      // Foi necessário executar a operação de de intersect dentro de um setTimeout, 
      // pois o mesmo trava a aplicação, impedindo a visualização do "loading".
      setTimeout(function () {        

        let arrIntersectedFeatures = intersectFeatures(getFeaturesTurf(arrSelectedLayers[0]), getFeaturesTurf(arrSelectedLayers[1]))
        arrIntersectedFeatures = arrIntersectedFeatures.filter((f) => f);     

        if(arrIntersectedFeatures.length > 0){
          let type = arrSelectedLayers[0].dataType
          setCollectionClip(turf.featureCollection(arrIntersectedFeatures));
          setSaveModalOpen(true);
          setType(type)
        }else {
          geoAlert({
            message: `Não é possível gerar a camada, pois não há interseção entre as feições`,
          });
        }   

        setRuningClip(false);   
        setLoadingInMap(false);
      }, 500);
    }      
  }, [runingClip, arrSelectedLayers, intersectFeatures, setLoadingInMap]);  
  
  /** EFFECTS */

  /**
   * Habilita ferramenta de acordo com a camada selecionada, visibilidade e tipo
   */
  useEffect(() => {
    let selectedLayers = layers.filter((l) => l.isSelected && l.visible);  
    if ((selectedLayers.length === 2
      && ['importada', 'criada'].includes(selectedLayers[0].type)
      && ['importada', 'criada'].includes(selectedLayers[1].type)
      && ["Polygon", "MultiPolygon"].includes(selectedLayers[1].dataType))
      ) {
        // Desabilita a ferramenta caso a camada de entrada seja do tipo linha
        if(["LineString", "MultiLineString"].includes(selectedLayers[0].dataType)){
          return setArrSelectedLayers([]);    
        }
        setArrSelectedLayers([selectedLayers[0], selectedLayers[1]]);
    } else {
      setArrSelectedLayers([]);
    }
  }, [layers]);

  /**
   * Desabilita ferramenta caso não haja camada selecionada
   */
  useEffect(() => {    
    if (arrSelectedLayers.length === 0 && isActive) {
      setIsActive(false);
    }
  }, [arrSelectedLayers, isActive, setIsActive]);

  /**
   * Reseta ferramenta ao ser desabilitada
   */
  useEffect(() => {
    if (!isActive) {      
      handleCloseSaveModal(); 
      setType('')  
    }
  }, [isActive, handleCloseSaveModal]);

  /**
   * Adiciona e executa um evento customizado. Ao final remove evento.
   */
  useEffect(() => {
    if (isActive && !runingClip) {
      map.on('run-clip', runClip);
      map.fire('run-clip'); 
      setIsActive(false);      
      map.off('run-clip');
    }
  }, [isActive, runingClip, map, runClip, setIsActive]);
  return (
    <Wrap>
      <ButtonTooltip
        tooltip={Clip.properties.alias}
        description={Clip.properties.description}
        onClick={() => {          
          setIsActive();          
        }}
        tooltipDisabled={isActive}
        active={isActive}
        disabled={arrSelectedLayers.length === 0}
      >        
        <Icon i="map-toolbar-clip"></Icon>
      </ButtonTooltip>    


      <CustomModalSaveAsLayer
        title="Salvar Camada"
        saveModalOpen={saveModalOpen}
        handleCloseSaveModal={handleCloseSaveModal}
        formik={formik}
        SliderColorPicker={ <SliderColorPicker
          geometryType={type || "Polygon"}
          autoSelect={false}
          selectedSymbology={formik.values.layerStyle}
          onSelect={(style) => formik.setFieldValue('layerStyle', style)}
        />}
      />  
    
    </Wrap>
  );
};

Clip.properties = {
  id: 'CPN-TB-A-CLIP',
  alias: 'Recortar',
  description: 'Extrair informações de uma camada que sobrepõem a área de recorte (interseção). Selecionando camadas criadas e/ou importadas, sendo uma camada de entrada do tipo polígono ou ponto (deve vim primeiro na lista de camadas) e outra camada de recortar (esta deverá ser do tipo polígono).',
};

export default Clip;
